import{ WebReportSDK } from '@/utils/utils'
import Vue from 'vue'
import App from './App.vue'
import Plugins from './plugins'
import router from "./router"
import 'iview/dist/styles/iview.css'
import './utils/flexible'
import i18n from './i18n'
import store from './store'
import message from '@/components/message/message.js'
import dialog from '@/components/dialog'
// import GSignInButton from 'vue-google-signin-button'
import utils from './utils'
import ENUM from '@/enum/const'
import socket from '@/server/ws'
// Vue.use(GSignInButton)
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'G-T9KQZ8ZRYC' }
})
if (process.env.VUE_APP_ENV !== 'prod'){
  import('vconsole')
      .then(res => {
        new res.default({ theme: 'dark' });
      } )
}

WebReportSDK()
import '@styles/reset.less'
Vue.use(message)
Vue.use(dialog)
Vue.use(Plugins)
Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$ENUM = ENUM
Vue.prototype.$socket = socket

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
